import { useQuery } from "@tanstack/react-query";
import { fetchHealth, fetchSyncStatus } from "../lib/api";
import { roleCan, useRole } from "../lib/roles";
import { PageSkeleton } from "../components/PageSkeleton";
import { SettingsWorkspace } from "../components/SettingsWorkspace";
import { PageHeader } from "../components/primitives";
import { AccessDenied } from "./NewsletterEditorPage";

export function SettingsPage() {
  const { role } = useRole();
  const health = useQuery({ queryKey: ["health"], queryFn: fetchHealth });
  const sync = useQuery({ queryKey: ["sync"], queryFn: fetchSyncStatus });

  if (!roleCan(role, "settings.write")) return <AccessDenied need="Admins" />;
  if (health.isLoading || sync.isLoading) return <PageSkeleton />;

  return (
    <div style={{ display: "grid", gap: "var(--ui-space-4)" }}>
      <PageHeader
        title="Settings"
        meta="Integrations, sync schedule, notifications, and environment configuration"
      />
      <SettingsWorkspace health={health.data} sync={sync.data} />
    </div>
  );
}
